'use strict';

var React = require('react');

var SvgSimplifyMajor = function SvgSimplifyMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m12.294 3.293-3 3a.997.997 0 0 0 0 1.414l3 3a1 1 0 1 0 1.414-1.414l-1.293-1.293h5.586a1 1 0 0 0 0-2h-5.586l1.293-1.293a1 1 0 0 0-1.414-1.414Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.708 9.293a1 1 0 1 0-1.415 1.414l1.293 1.293h-5.586a1 1 0 1 0 0 2h5.586l-1.293 1.293a1.002 1.002 0 0 0 0 1.414.998.998 0 0 0 1.415 0l3-3a.997.997 0 0 0 0-1.414l-3-3Z"
  }));
};

exports.SvgSimplifyMajor = SvgSimplifyMajor;
